import { createKey, encrypt, decrypt } from "../../common/utils/crypto";
import { login } from "./tempAccounts";
export { projects } from "./tempAccounts";

const SESSION_ID = "WSD/H456";

export const auth = (username, password) => {
  return new Promise(function (resolve, reject) {
    try {
      let u = login(username, password);
      // console.log('u: %o', u);
      resolve(u);
    } catch (err) {
      reject(err);
    }
  });
};

export const getUserDetails = (username, password) => {
  return new Promise(function (resolve, reject) {
    try {
      let user = login(username, password);
      //delete user.password;
      resolve(user);
    } catch (err) {
      reject(err);
    }
  });
};

export const storeUser = ({ username, password, timestamp }) => {
  localStorage.setItem(
    SESSION_ID,
    encrypt(
      username + ":::" + password + ":::" + timestamp,
      createKey(SESSION_ID)
    )
  );
};

export const removeUser = () => {
  localStorage.removeItem(SESSION_ID);
};

export const getUser = () => {
  try {
    const [username, password, timestamp] = decrypt(
      localStorage.getItem(SESSION_ID),
      createKey(SESSION_ID)
    ).split(":::");
    return { username, password, timestamp };
  } catch (ex) {
    return undefined;
  }
};
